<div class="container-fluid ps-0">
  <div class="row">
    @if (handelssortimentsgrupperOptions) {
      <rask-tree-selector
        id="handelssortimentsgrupper"
        class="col-6"
        label="Handelssortimentsgrupper"
        placeholder="Lägg till handelssortimentsgrupp"
        [disabled]="kontraktReadonly"
        [disableDeleteAll]="true"
        [manualItemSync]="true"
        (change)="handelssortimentsgruppOptionChanged()"
        [items]="handelssortimentsgrupperOptions">
      </rask-tree-selector>
    }

    <div class="col-1"></div>

    @if (!isLeveransvirke && !isGrotKontrakt) {
      <div class="col-5 px-0" [ngClass]="utbyteTopMargin">
        <rask-beraknat-utbyte-button>
        </rask-beraknat-utbyte-button>
      </div>
    }
  </div>

  <div class="row mb-3">
    @if (minaHandelssortimentOptions) {
      <rask-tree-selector
        class="col-6"
        id="minahandelssortiment"
        label="Mina handelssortiment"
        placeholder="Lägg till handelssortiment"
        [disabled]="kontraktReadonly"
        [disableDeleteAll]="true"
        [showHeader]="true"
        [manualItemSync]="true"
        (change)="handelssortimentOptionChanged()"
        [items]="minaHandelssortimentOptions">
        <ng-container header>
          <div class="custom-highlight" (click)="openMinaHandelssortiment()">
            <a href="javascript: void(0)">Mina handelssortiment <i class="far fa-external-link" aria-hidden="true"></i></a>
          </div>
        </ng-container>
      </rask-tree-selector>
    }

    <rask-textmultiline class="col-1" label="">
      <rask-button class="hamta-mina-handelssortiment" [disabled]="kontraktReadonly" color="tertiary" (click)="clickApplyMinaHandelssortiment()"
      icon="fas fa-sync"></rask-button>
    </rask-textmultiline>

    <rask-selector
      class="col-5"
      id="minaforkalkylsmallar"
      label="Mina förkalkylsmallar"
      [disabled]="kontraktReadonly"
      [showHeader]="true"
      placeholder="Använd mall"
      [formatter]="genericSSItemFormatter"
      [viewFormatter]="genericSSViewFormatter"
      (change)="forkalkylsmallSelected($event)"
      [values]="forkalkylsmallarOptions">
      <ng-container header>
        <div class="custom-highlight" (click)="openRedigeraForkalkylsmallar()">
          <a href="javascript:void(0)">Mina förkalkylsmallar <i class="far fa-external-link" aria-hidden="true"></i></a>
        </div>
      </ng-container>
    </rask-selector>
  </div>

  <div class="row">
    <rask-beraknat-utbyte-validation [warnings]="warnings">
    </rask-beraknat-utbyte-validation>
  </div>

  <div class="row">
    <div class="col-12">
      @if (hotDoc) {
        <rask-hot-doc
          [canEdit]="!kontraktReadonly"
          [hotDoc]="hotDoc">
        </rask-hot-doc>
      }
    </div>
    <rask-skapa-mall-fran-handelssortiment [handelssortimentRows]="rowsForForkalkylsmallCreation"
    (refreshMinaForkalkylsmallar)="refreshMinaForkalkylsmallar()"></rask-skapa-mall-fran-handelssortiment>
  </div>
</div>